export default "__VITE_ASSET__DRkHch2p__"